<template>
  <div class="forgot-page">
    <!-- 顶部返回（白色箭头，位于渐变背景上） -->
    <div class="back-btn" @click="goBack">
      <svg viewBox="0 0 24 24" class="back-icon">
        <path d="M15 18 L9 12 L15 6" fill="none" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>

    <!-- 顶部品牌区：青绿渐变背景 + 徽章 + 名称 -->
    <div class="brand">
      <img src="@/assets/icons/rsj-logo.png" class="brand-logo" alt="logo" />
      <div class="brand-name">江苏智慧人社</div>
    </div>

    <!-- 表单：证件类型/证件号/姓名 -->
    <div class="form-panel">
      <select
        v-model="certType"
        :class="['form-select', { placeholder: !certType }]"
      >
        <option value="" disabled>请选择证件类型</option>
        <option value="居民身份证">居民身份证</option>
        <option value="港澳台居民居住证">港澳台居民居住证</option>
        <option value="护照">护照</option>
      </select>
      <input
        v-model.trim="idNo"
        class="form-input"
        type="text"
        placeholder="请输入证件号"
      />
      <input
        v-model.trim="name"
        class="form-input"
        type="text"
        placeholder="请输入姓名"
      />

      <!-- 下一步 -->
      <div class="btn-next" @click="goNext">下一步</div>

      <!-- 协议勾选 -->
      <div class="agreement-row" @click="agreed = !agreed">
        <span :class="['checkbox', { checked: agreed }]">
          <svg v-if="agreed" viewBox="0 0 24 24" class="check-icon">
            <path d="M5 12.5 L10 17.5 L19 7" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </span>
        <span class="agreement-text">
          我已阅读并同意<a class="link-text" @click.stop="goAgreement('用户协议')">《用户协议》</a> 、<a class="link-text" @click.stop="goAgreement('隐私协议')">《隐私协议》</a>中的内容
        </span>
      </div>

      <!-- 操作说明 -->
      <div class="op-note">
        <p>操作说明：</p>
        <p>1.请准确填写本人的账号信息。</p>
        <p>2.账号持有者本人完成人脸识别认证后进行密码重置。</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ForgotPassword',
  data() {
    return {
      certType: '',
      idNo: '',
      name: '',
      agreed: false
    }
  },
  methods: {
    goBack() {
      if (window.history.length > 1) {
        this.$router.back()
      } else {
        this.$router.replace('/login')
      }
    },
    goAgreement(name) {
      this.$router.push(name === '用户协议' ? '/agreement-user' : '/privacy')
    },
    goNext() {
      if (!this.certType) {
        this.$alert('请选择证件类型')
        return
      }
      if (!this.idNo) {
        this.$alert('请输入证件号')
        return
      }
      if (!/^\d{17}[\dXx]$/.test(this.idNo)) {
        this.$alert('请输入正确的证件号码')
        return
      }
      if (!this.name) {
        this.$alert('请输入姓名')
        return
      }
      if (!this.agreed) {
        this.$alert('请先阅读并同意《用户协议》、《隐私协议》中的内容')
        return
      }
      this.$alert('信息验证通过，请完成人脸识别认证后进行密码重置')
    }
  }
}
</script>

<style scoped>
.forgot-page {
  min-height: 100%;
  background: #fff;
  /* 顶部青绿渐变山水底色，向下淡出为白色（参照设计稿） */
  background: linear-gradient(180deg, #5FC0B8 0%, #8AD2CB 22%, #FFFFFF 34%);
  background-color: #fff;
}
.back-btn {
  position: absolute;
  left: calc(24 * var(--w));
  top: calc(56 * var(--w));
  width: calc(64 * var(--w));
  height: calc(64 * var(--w));
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 2;
}
.back-icon {
  width: calc(40 * var(--w));
  height: calc(40 * var(--w));
}

/* 品牌区 */
.brand {
  padding-top: calc(214 * var(--w));
  display: flex;
  flex-direction: column;
  align-items: center;
}
.brand-logo {
  /* 白色圆角方形 App 图标底托，内含圆形徽章 */
  width: calc(240 * var(--w));
  height: calc(240 * var(--w));
  padding: calc(20 * var(--w));
  box-sizing: border-box;
  object-fit: contain;
  background: #fff;
  border-radius: calc(52 * var(--w));
  box-shadow: 0 calc(8 * var(--w)) calc(24 * var(--w)) rgba(0, 0, 0, 0.08);
}
.brand-name {
  margin-top: calc(30 * var(--w));
  font-size: calc(52 * var(--w));
  color: #3A3A3A;
  font-weight: 500;
}

/* 表单 */
.form-panel {
  padding: 0 calc(90 * var(--w));
}
.form-select,
.form-input {
  display: block;
  margin-top: calc(66 * var(--w));
  width: 100%;
  height: calc(96 * var(--w));
  border: none;
  border-bottom: 1px solid #E3E5E8;
  border-radius: 0;
  background: transparent;
  padding: 0;
  font-size: calc(44 * var(--w));
  color: #323233;
  font-family: inherit;
  outline: none;
  -webkit-appearance: none;
  appearance: none;
}
.form-select.placeholder {
  color: #C3C8CF;
}
.form-select option {
  color: #323233;
}
.form-input::placeholder {
  color: #C3C8CF;
}

/* 下一步按钮 */
.btn-next {
  margin-top: calc(100 * var(--w));
  height: calc(110 * var(--w));
  border-radius: calc(28 * var(--w));
  background: #3B97E8;
  color: #fff;
  font-size: calc(48 * var(--w));
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.btn-next:active {
  background: #2F86D4;
}

/* 协议勾选 */
.agreement-row {
  margin-top: calc(44 * var(--w));
  display: flex;
  align-items: center;
  cursor: pointer;
}
.checkbox {
  width: calc(40 * var(--w));
  height: calc(40 * var(--w));
  border: 1px solid #C3C8CF;
  border-radius: calc(6 * var(--w));
  background: #fff;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.checkbox.checked {
  border-color: #3B97E8;
  background: #3B97E8;
}
.check-icon {
  width: calc(26 * var(--w));
  height: calc(26 * var(--w));
}
.agreement-text {
  margin-left: calc(16 * var(--w));
  font-size: calc(38 * var(--w));
  color: #333;
  line-height: 1.4;
}
.link-text {
  font-size: calc(38 * var(--w));
  color: #4A90D9;
  cursor: pointer;
}

/* 操作说明 */
.op-note {
  margin-top: calc(190 * var(--w));
}
.op-note p {
  margin: 0;
  font-size: calc(38 * var(--w));
  color: #666;
  line-height: 1.9;
}
</style>



// WEBPACK FOOTER //
// src/pages/ForgotPassword.vue